module.exports = __webpack_public_path__ + "img/sc_bg.6eaf299e.png";